import type { ReactNode } from "react";

/**
 * La pastille de filtre, ou de choix entre deux options exclusives.
 *
 * Reprise de `designSystem/atoms/ToggleChip.tsx` du proto : un `button` en
 * `rounded-full` qui annonce son état par `aria-pressed`. L'état SÉLECTIONNÉ, lui,
 * vient de l'espace entreprise (trait et texte d'action sur `mg-selected`) et pas
 * de l'aplat du proto : un filtre en aplat marine devenait l'élément le plus fort
 * de l'écran, plus fort que le bouton qui publie une offre.
 *
 * Elle existait en trois copies (les filtres des offres de l'entreprise, ceux de
 * l'école, le choix du destinataire), dont deux refaites en `Button` primaire et
 * secondaire, chacune avec son format de compte. Le compte s'écrit ici, une fois :
 * le chiffre après le libellé, sans parenthèses.
 *
 * 44px sous `md`, la cible d'un pouce ; 32px au-dessus, la hauteur d'un petit bouton.
 */
export function FilterChip({
	selected,
	onClick,
	count,
	icon,
	children,
}: {
	selected: boolean;
	onClick: () => void;
	/** Le nombre d'éléments que le filtre montre. Absent pour un choix sans compte. */
	count?: number;
	icon?: ReactNode;
	children: ReactNode;
}) {
	return (
		<button
			type="button"
			aria-pressed={selected}
			onClick={onClick}
			className={`t-label inline-flex min-h-11 items-center gap-1.5 rounded-full border px-4 transition-colors md:min-h-8 md:px-3 ${
				selected
					? "border-mg-action bg-mg-selected text-mg-action"
					: "border-mg-border-strong bg-mg-surface text-mg-body hover:bg-mg-hover"
			}`}
		>
			{icon}
			<span className="whitespace-nowrap">{children}</span>
			{count === undefined ? null : <span className="tabular-nums font-normal">{count}</span>}
		</button>
	);
}
